import { Button, Card, Col, Form, Row, Spinner, Stack } from "react-bootstrap";
import { SYSTEM_NAME } from "../../layouts/LayoutPrincipal/LayoutPrincipal";
import { ContextAlerta } from "../../contexts/ContextAlert";
import { useCallback, useContext, useState } from "react";
import api, { tCredenciais } from "../../services/api";
import { Formik, FormikHelpers } from "formik";
import { useNavigate } from "react-router-dom";
import { v4 } from "uuid";

import FrontRoutes from "../../lib/front-routes";
import InputSenha from "../inputs/InputSenha";
import MyLink from "../links/MyLink";
import utils from "../../utils";

import "./login-cardStyle.css";
import * as yup from "yup";

export default function CardLogin() {
    //CONTEXTOS
    const { setPerigo } = useContext(ContextAlerta);
    const navigate = useNavigate();

    //ESTADOS
    const [logando, setLogando] = useState(false);

    //EVENTOS
    const handleSubmit = useCallback(
        async (credenciais: tCredenciais, helpersFormik: FormikHelpers<tCredenciais>) => {
            setLogando(true);
            try {
                await api.login(credenciais);
                helpersFormik.setSubmitting(false);
                navigate(FrontRoutes.getLogged());
            } catch (err) {
                console.error(err);
                setPerigo(utils.retornaMensagemErro(err));
            } finally {
                setLogando(false);
            }
        },
        [navigate, setPerigo]
    );

    return (
        <Card className="my-card-login border-0">
            <Card.Body className="my-card-login-body">
                <Col sm="12" className="text-center mb-4">
                    <Stack className="d-flex align-items-center gap-2">
                        <div className="my-logo-wrapper">
                            <img className="my-img-logo" alt="logo" src="/ALTUS-12.png" />
                        </div>
                        <h4 className="my-login-title mb-0">{SYSTEM_NAME}</h4>
                        <small className="text-muted">
                            <span>Protect Solutions | Nextgen | Ellvor </span>
                        </small>
                    </Stack>
                </Col>
                <Col sm="12">
                    <Formik
                        validateOnChange={false}
                        validationSchema={esquemaLogin}
                        onSubmit={handleSubmit}
                        initialValues={{ email: "", password: "" }}
                    >
                        {({ handleSubmit, handleChange, setValues, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit} className="text-end">
                                <Row className="mb-4 text-start">
                                    <Form.Group as={Col} sm="12" controlId={v4()} className="mb-3">
                                        <Form.Label className="my-login-label">E-mail</Form.Label>
                                        <Form.Control
                                            placeholder="Digite seu e-mail"
                                            autoComplete="username"
                                            type="email"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            isInvalid={!!errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} sm="12" controlId={v4()} className="mb-2">
                                        <Form.Label className="my-login-label">Senha</Form.Label>
                                        <InputSenha
                                            placeholder="Digite sua senha"
                                            autoComplete="current-password"
                                            valor={values.password}
                                            onAccept={(password) => setValues({ ...values, password })}
                                            isInvalid={!!errors.password}
                                            error={errors.password}
                                        />
                                    </Form.Group>
                                    <Col sm="12" className="my-login-forgot">
                                        <MyLink to={FrontRoutes.getRecuperarSenha()}>Esqueceu sua senha?</MyLink>
                                    </Col>
                                </Row>

                                <Button className="my-btn-login w-100" type="submit" disabled={logando}>
                                    Entrar {logando && <Spinner size="sm" animation="border" className="ms-1" />}
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Card.Body>
        </Card>
    );
}

const esquemaLogin: yup.ObjectSchema<tCredenciais> = yup.object({
    email: yup.string().required("Este campo é necessário.").email("Insira um e-mail válido."),
    password: yup.string().required("Este campo é necessário."),
});
